export function SET_CURRENT_PRESCRIPTION(state, prescription) {
    state.prescriptionSelected = prescription;
  }
  